import type { FlexProps as ChakraFlexProps } from '@chakra-ui/react';

export interface FlexProps extends ChakraFlexProps {}

export const FlexDefaultProps: FlexProps = {};
